import { render, staticRenderFns } from "./PaymentIcon.vue?vue&type=template&id=002d69a9&"
import script from "./PaymentIcon.vue?vue&type=script&lang=js&"
export * from "./PaymentIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports